<template>
    <el-container>
        <el-header style="padding: 0; min-height: 30px;">
            <el-page-header @back="goBack" content="分配课程"></el-page-header>
        </el-header>
        <el-dialog
            :title="courseDialog.title"
            :visible.sync="courseDialog.show"
            width="60%"
            :close-on-click-modal=false
            :before-close="courseClose"
            top="10vh"
        >
            <el-form ref="courseForm" :model="courseDialog.searchData" label-width="80px">
                <el-row>
                    <el-col :span="7">
                        <el-form-item label="组织机构" prop="orgCode">
                            <el-select
                                placeholder="组织机构"
                                clearable
                                size="small"
                                v-model="courseDialog.searchData.orgCode"
                                style="margin-right: 10px; "
                                @change="changeCourseOrgCode"
                            >
                                <el-option
                                    v-for="o in org"
                                    :label="o.organizationName"
                                    :value="o.orgCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="课程分类:" :inline="true" prop="courseType">
                            <el-cascader
                                expand-trigger="hover"
                                :options="courseDialog.courseTypeOptions"
                                style
                                clearable
                                :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
                                v-model="courseDialog.selectedCourseType"
                                @change="changeCourseType"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="已购商品" prop="name">
                            <el-input
                                v-model="courseDialog.searchData.name"
                                placeholder="课程名称"
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button
                            style="margin-left:20px;"
                            type="primary"
                            icon="el-icon-search"
                            @click="searchCourse()"
                        >搜索</el-button>
                    </el-col>
                </el-row>已购商品
            </el-form>
            <el-table
                :data="courseDialog.dataList"
                border
                ref="multipleTable"
                highlight-current-row
                v-loading="courseDialog.loading"
                style="width: 100%; margin-bottom: 20px;"
                @selection-change="handleCourseSelectChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="课程名称" fixed="left"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="courseDialog.total"
                :page-size="courseDialog.pageSize"
                :current-page.sync="courseDialog.currentPage"
                @size-change="handleCourseSizeChange"
                @current-change="handleCourseCurrentChange"
                style="margin-top: -5px; float: right; margin-right: 10px"
            ></el-pagination>
            <el-form style="clear:both;">
                <el-form-item>
                    <el-button
                        type="success"
                        size="small"
                        icon="el-icon-search"
                        @click="courseCancel()"
                    >取消</el-button>
                    <el-button
                        type="success"
                        size="small"
                        icon="el-icon-search"
                        @click="courseSave()"
                    >确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog
            :title="studentDialog.title"
            :visible.sync="studentDialog.show"
            width="60%"
            :close-on-click-modal=false
            :before-close="studentClose"
            top="10vh"
        >
            <el-form ref="studentForm" :model="studentDialog.searchData" label-width="80px" label-position="top">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="用户名/手机号/邮箱/姓名" prop="allAccount">
                            <el-input
                                placeholder="用户名/手机号/邮箱/姓名"
                                size="small"
                                v-model="studentDialog.searchData.allAccount"
                                style="width:90%;"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="组织机构" prop="orgCode" >
                            <el-select
                                placeholder="组织机构"
                                clearable
                                size="small"
                                v-model="studentDialog.searchData.orgCode"
                                style="width: 90%"
                                @change="changeStudentOrgCode"
                            >
                                <el-option
                                    v-for="o in org"
                                    :label="o.organizationName"
                                    :value="o.orgCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="来源" clearable prop="source">
                            <el-select
                                v-model="studentDialog.searchData.source"
                                clearable
                                placeholder="来源"
                                size="small"
                                style="width: 90%"
                                @change="changeStudentSource"
                            >
                                <el-option label="已缴费学生" :value="32" ></el-option>
                                <el-option label="批量导入" :value="16"></el-option>
                                <el-option label="单个添加" :value="8"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="批次" clearable>
                            <el-select
                                placeholder="批次"
                                clearable
                                size="small"
                                v-model="studentDialog.searchData.banch"
                                style="margin-right: 10px; width: 90%"
                                :disabled="!studentDialog.isBanch"
                                @change="changeStudentBanth"
                            >
                                <el-option
                                    v-for="o in studentDialog.banchList"
                                    :label="o"
                                    :value="o"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="已购商品" v-if="showYH">
                            <el-input
                                v-model="studentDialog.searchData.courseName"
                                placeholder="已购商品"
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-button type="primary" plain size="small" @click="searchStudent()">查询</el-button>
            <el-button type="success" size="small" @click="studentSave()">确定</el-button><br>
            <el-table
                :data="studentDialog.dataList"
                border
                ref="multipleTable"
                highlight-current-row
                v-loading="studentDialog.loading"
                style="width: 100%; margin-top: 20px;"
                @selection-change="handleStudentSelectChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="userName" label="用户名" width="200" fixed="left"></el-table-column>
                <el-table-column prop="realName" label="姓名" width="100"></el-table-column>
                <el-table-column prop="courseName" label="已购商品名" v-if="showYH" ></el-table-column>
                <el-table-column prop="paymentTime" label="购入时间" v-if="showYH" width="300"></el-table-column>
                <el-table-column prop="orgName" label="组织机构" v-if="!showYH"></el-table-column>
                <el-table-column prop="source" label="来源" width="200" :formatter="sourceFormat" v-if="!showYH"></el-table-column>
                <el-table-column prop="banch" label="批次" width="200" v-if="!showYH"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="studentDialog.total"
                :page-size="studentDialog.pageSize"
                :current-page.sync="studentDialog.currentPage"
                @size-change="handleCourseSizeChange"
                @current-change="handleStudentCurrentChange"
                style="text-align: right"
            ></el-pagination>
        </el-dialog>

        <el-main>
            <el-form ref="formData" :model="formData" label-width="100px">
                <el-form-item label="分配课程：" prop="courseList">
                    <el-button
                        type="success"
                        icon="el-icon-circle-plus-outline"
                        size="small"
                        round
                        @click="courseOpen"
                        class="but-cls"
                    >选择课程</el-button>
                    <el-tag
                        v-for="course in courseTag"
                        :key="course.courseId"
                        :disable-transitions="true"
                        @close="handleCloseCourseTag(course)"
                        closable
                        style="margin-left:10px"
                    >{{course.name}}</el-tag>
                </el-form-item>
                <el-form-item label="关联学生：" prop="student">
                    <el-button
                        type="success"
                        icon="el-icon-circle-plus-outline"
                        size="small"
                        round
                        @click="studentOpen"
                        class="but-cls"
                    >选择学生</el-button>
                    <el-tag
                        v-for="student in studentTag"
                        :key="student.key"
                        :disable-transitions="true"
                        @close="handleCloseStudentTag(student)"
                        closable
                        style="margin-left:10px"
                    >{{student.name}}</el-tag>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-search"
                        @click="onSubmit()"
                    >确定</el-button>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</template>

<script>
import https from '@/https.js';
import validate from '@/api/validate.js';

const courseForm = {
    orgCode: '',
    courseTypeList: []
};
const studentForm = {
    orgCode: '',
    source: '',
    banch: '',
    page: 1,
    size: 0
};

export default {
    data() {
        return {
          user: '',
             loginOrgCode: '',
            orgCode: 'eblcu',
            orgType:'',
            showYH: false,
            org: [],
            orgBanchList: [],
            title: '选择课程',
            //region 课程弹框
            courseDialog: {
                show: false,
                searchData: {
                    orgCode: '',
                    courseTypeList: [],
                    name: ''
                },
                selectedOrgData: {},
                loading: false,
                dataList: [],
                total: 0,
                pageSize: 10,
                currentPage: 1,
                //课程分类
                courseTypeOptions: [],
                selectedCourseType: [],
                selectedCourse: []
            },
            //endregion 课程

            //region 学生弹框
            studentDialog: {
                show: false,
                searchData: {
                    orgCode: '',
                    source: '',
                    banch: '',
                    allAccount: '',
                    page: 1,
                    size: 10
                },
                selectedOrgData: {},
                loading: false,
                dataList: [],
                total: 0,
                pageSize: 10,
                currentPage: 1,
                isBanch: false,
                selectedStudent: [],
                //批次列表
                banchList: []
            },

            //endregion

            formData: {
                orgCode: '',
                courseList: [],
                studentList: []
            },
            courseTag: [],
            //[{source,name,key}]
            studentTag: []
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        selectOrg() {
            https
                .fetchGet('/managerOrganization/getOrganizationList', '', 'from')
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.org = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: msg
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error('网络错误');
                });
        },
        selectOrgBanch() {
            let params = {
                orgCode: '',
                source: ''
            };
            let that = this;
            https
                .fetchPost('/managerStudent/getBanchList', params, 'json')
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        that.orgBanchList = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败:' + msg
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error('网络错误');
                });
        },
        //region 课程
        courseOpen() {
            this.courseDialog.show = true;
            this.courseDialog.courseTypeOptions = [];
            this.courseDialog.selectedCourseType = [];
            this.courseDialog.searchData = JSON.parse(JSON.stringify(courseForm));
            this.courseDialog.dataList = [];
        },
        courseClose() {
            this.courseDialog.show = false;
            this.courseDialog.searchData = JSON.parse(JSON.stringify(courseForm));
            this.courseDialog.total=0;
            this.courseDialog.pageSize=10;
            this.courseDialog.currentPage=1;
        },
        courseCancel() {
            this.courseDialog.show = false;
            this.courseDialog.searchData = JSON.parse(JSON.stringify(courseForm));
            this.courseDialog.total=0;
            this.courseDialog.pageSize=10;
            this.courseDialog.currentPage=1;
        },
        courseSave() {
            if (this.courseDialog.selectedCourse.length < 1) {
                this.$message.error('请选择课程');
                return;
            }
            console.log(this.courseDialog.selectedCourse);
            for (var item of this.courseDialog.selectedCourse) {
                console.log(item);
                let isExt = this.courseTag.findIndex(function (t) {
                    return t.courseId == item.courseId;
                });

                if (isExt < 0) {
                    this.courseTag.push(item);
                }
            }
            this.courseDialog.total=0;
            this.courseDialog.pageSize=10;
            this.courseDialog.currentPage=1;
            this.courseDialog.show = false;
        },
        //选择课程
        handleCourseSelectChange(val) {
            console.log(val);
            this.courseDialog.selectedCourse = [];
            for (let index in val) {
                let course = {
                    courseId: val[index].courseId,
                    name: val[index].name
                };
                this.courseDialog.selectedCourse.push(course);
            }
        },
        handleCourseSizeChange() {},
        handleCourseCurrentChange(val) {
            this.searchCourse(val);            
        },
        //获取课程类目
        searchCourseType(val) {
            let params = {
                orgCode: this.courseDialog.searchData.orgCode
            };
            this.courseDialog.courseTypeOptions = [];
            this.https
                .fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json')
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.courseDialog.courseTypeOptions = data.data.data.childNodeLst;
                    } else {
                        // this.$message({
                        //     type: "info",
                        //     message: "加载失败:" + msg,
                        // });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error('网络错误');
                });
        },
        //更改机构
        changeCourseOrgCode(val) {
            if (!val) {
                this.courseDialog.courseTypeOptions = [];
                return;
            }
            this.courseDialog.selectedOrgData = val;
            this.searchCourseType();
        },
        //更改课程分类
        changeCourseType(val) {
            console.log(val);
            if (val.length > 0) {
                //this.searchCourse(val);
            }
        },
        //查询课程
        searchCourse(val) {
            console.log('val的值'+val);
            if (val) {
                this.courseDialog.currentPage = val;
            } else {
                this.courseDialog.currentPage = 1;
            }

            let selectedCourseType = this.courseDialog.selectedCourseType;
            console.log(selectedCourseType);
            let params = {
                orgCode: this.courseDialog.searchData.orgCode,
                name: this.courseDialog.searchData.name,
                page: this.courseDialog.currentPage,
                limit: this.courseDialog.pageSize
            };
            if (selectedCourseType && selectedCourseType.length > 0) {
                switch (selectedCourseType.length) {
                    case 1:
                        params.categoryOne = selectedCourseType[selectedCourseType.length - 1];
                        break;
                    case 2:
                        params.categoryTwo = selectedCourseType[selectedCourseType.length - 1];
                        break;
                    case 3:
                        params.categoryThree = selectedCourseType[selectedCourseType.length - 1];
                        break;
                }
            }

            this.courseDialog.loading = true;
            this.https
                .fetchPost('/course/getCourseByType', params, 'json')
                .then((data) => {
                    this.courseDialog.loading = false;
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.courseDialog.dataList = data.data.data;
                        this.courseDialog.total = data.data.total;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败:' + msg
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.courseDialog.loading = false;
                    this.$message.error('网络错误');
                });
        },
        handleCloseCourseTag(tag) {
            this.courseTag.splice(this.courseTag.indexOf(tag), 1);
        },
        //endregion 课程

        //region 学生

        studentOpen() {
            this.studentDialog.show = true;
            this.studentDialog.searchData = JSON.parse(JSON.stringify(studentForm));
            this.studentDialog.dataList = [];
        },
        studentClose() {
            this.studentDialog.show = false;
            this.studentDialog.searchData = JSON.parse(JSON.stringify(studentForm));
            this.studentDialog.total=0;
            this.studentDialog.pageSize=10;
            this.studentDialog.currentPage=1;
        },
        studentCancel() {
            this.studentDialog.show = false;
            this.studentDialog.searchData = JSON.parse(JSON.stringify(studentForm));
            this.studentDialog.total=0;
            this.studentDialog.pageSize=10;
            this.studentDialog.currentPage=1;
        },
        studentSave() {
            if (!this.studentDialog.searchData.orgCode) {
                this.$message.error('请选择组织机构');
                return;
            }
            if (!this.studentDialog.searchData.source) {
                this.$message.error('请选择来源');
                return;
            } else if (this.studentDialog.searchData.source == 8 || this.studentDialog.searchData.source == 32) {
                let orgCode = this.studentDialog.searchData.orgCode;
                let orgName = this.org
                    .filter((item) => {
                        return item.orgCode == orgCode;
                    })
                    .map(function (orgModel) {
                        return orgModel.organizationName;
                    });

                //单个添加
                if (this.studentDialog.selectedStudent.length < 1) {
                    this.$message.error('请选择学生');
                    return;
                }
                console.log(this.studentDialog.selectedStudent);
                for (var item of this.studentDialog.selectedStudent) {
                    console.log(item);
                    let isExt = this.studentTag.findIndex(function (t) {
                        return t.source == 8 && t.key == item.userName;
                    });

                    if (isExt < 0) {
                        let newModel = {
                            source: 8,
                            name: orgName + ' ' + item.userName,
                            key: item.userName
                        };
                        this.studentTag.push(newModel);
                    }
                }
            } else if (this.studentDialog.searchData.source == 16) {
                //批量添加
                if (!this.studentDialog.searchData.banch) {
                    this.$message.error('请选择批次');
                    return;
                }
                let orgCode = this.studentDialog.searchData.orgCode;
                let orgName = this.org
                    .filter((item) => {
                        return item.orgCode == orgCode;
                    })
                    .map(function (orgModel) {
                        return orgModel.organizationName;
                    });
                let thisBanch = this.studentDialog.searchData.banch;
                console.log();
                let isExt = this.studentTag.findIndex(function (t) {
                    return t.source == 16 && t.key == thisBanch;
                });
                if (isExt < 0) {
                    let newModel = {
                        source: 16,
                        name: orgName + ' ' + this.studentDialog.searchData.banch + ' ' + '批次',
                        key: this.studentDialog.searchData.banch
                    };
                    this.studentTag.push(newModel);
                }
            }
            this.studentDialog.total=0;
            this.studentDialog.pageSize=10;
            this.studentDialog.currentPage=1;
            this.studentDialog.show = false;
        },
        //更改机构
        changeStudentOrgCode(val) {
            console.log(val);
            this.studentDialog.searchData.source = '';
            this.studentDialog.searchData.banch = '';
            this.studentDialog.total=0;
            this.studentDialog.pageSize=10;
            this.studentDialog.currentPage=1;
            this.studentDialog.isBanch = false;
            for (let i = 0, len = this.orgBanchList.length; i < len; i++) {
                if (this.orgBanchList[i].orgCode == val) {
                    this.studentDialog.banchList = this.orgBanchList[i].banchList;
                }
            }
            this.studentDialog.selectedOrgData = val;
        },
        //更改来源
        changeStudentSource(val) {
            this.studentDialog.total=0;
            this.studentDialog.pageSize=10;
            this.studentDialog.currentPage=1;
            this.showYH = false;
            if (val == 16) {
                //批量导入
                this.studentDialog.isBanch = true;
                this.studentDialog.searchData.banch = '';
                this.studentDialog.dataList = [];
            } else if (val == 8) {
                //单个填加
                this.studentDialog.isBanch = false;
                this.studentDialog.searchData.banch = '';
            } else if(val == 32){
              this.studentDialog.dataList = [];
              this.showYH = true;
            }else {
                this.studentDialog.dataList = [];
                this.studentDialog.searchData.banch = '';
            }
        },
        //更改批次
        changeStudentBanth(val) {
            // if (val) {
            //     this.searchStudent();
            // } else {
            //     this.studentDialog.dataList = [];
            // }
        },
        handleStudentSelectChange(val) {
            console.log(val);
            this.studentDialog.selectedStudent = [];
            for (let index in val) {
                let model = {
                    accountId: val[index].accountId,
                    userName: val[index].userName
                };
                this.studentDialog.selectedStudent.push(model);
            }
        },
        handleStudentSizeChange() {},
        handleStudentCurrentChange(val) {
          this.searchStudent(val);
        },
        searchStudent(val) {
          if(this.studentDialog.searchData.source == 16) {
            return;
          }
            if (val) {
                this.studentDialog.searchData.page = val;
            } else {
                this.studentDialog.searchData.page = 1;
                this.studentDialog.currentStudentPage = 1;
            }
            this.studentDialog.searchData.size = 10;
            console.log(this.studentDialog.searchData);
            let params = this.studentDialog.searchData;
            this.studentDialog.loading = true;
            https
                .fetchPost('/managerStudent/search', JSON.parse(JSON.stringify(params)), 'json')
                .then((data) => {
                    this.studentDialog.loading = false;
                    let code = data.data.code;
                    if (code == 200) {
                        this.studentDialog.dataList = data.data.data;
                        this.studentDialog.total = data.data.total;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.studentDialog.loading = false;
                    this.$message.error('数据加载失败');
                });
        },
        sourceFormat(row, column, cellValue, index) {
            if (cellValue != null) {
                let result = '';
                switch (cellValue) {
                    case 16:
                        result = '批量导入';
                        break;
                    case 8:
                        result = '单个添加';
                        break;
                    case 1:
                        result = '用户注册';
                        break;
                    case 2:
                        result = '用户注册';
                        break;
                }
                return result;
            } else {
                return cellValue;
            }
        },
        handleCloseStudentTag(tag) {
            this.studentTag.splice(this.studentTag.indexOf(tag), 1);
        },
        //endregion 学生

        //提交
        onSubmit() {
            let courseTag = this.courseTag;
            let studentTag = this.studentTag;
            if (courseTag.length < 1) {
                this.$message.error('请选择分配课程');
                return;
            }
            if (studentTag.length < 1) {
                this.$message.error('请选择关联学生');
                return;
            }
            let courseIdList = courseTag.map(function (course) {
                return course.courseId;
            });
            let userNameList = studentTag
                .filter((item) => {
                    return item.source == 8;
                })
                .map(function (student) {
                    return student.key;
                });
            let banchList = studentTag
                .filter((item) => {
                    return item.source == 16;
                })
                .map(function (student) {
                    return student.key;
                });
            let params = {
                courseIdList: courseIdList,
                userNameList: userNameList,
                banchList: banchList
            };
            this.https
                .fetchPost('/managerStudent/allocateStudentCourse', JSON.parse(JSON.stringify(params)), 'json')
                .then((data) => {
                    this.studentDialog.loading = false;
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == '200') {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.goBack();
                    } else {
                        this.$message.error('操作失败:' + msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.studentDialog.loading = false;
                    this.$message.error('数据加载失败');
                });
        }
    },
    created: function () {
        this.orgType = this.$store.state.orgType;
        this.loginOrgCode = this.$store.state.orgCode;
        this.studentDialog.searchData.orgCode = this.loginOrgCode;
        this.user = this.$store.state.user;
        this.selectOrg();
        this.selectOrgBanch();
    }
};
</script>
<style>
    .el-dialog__footer {
        height: 80px;
    }
</style>
